import(/* webpackMode: "eager" */ "/app/apps/eurodrive/app/[locale]/not-found.tsx");
